import React, {useContext} from "react";
import CloseWindowIcon from "../Assets/Images/close-window.svg";
import ComparativeTable from "./ComparativeTable";
import {DataContext} from "../Context/DataContext";
import References from "../Assets/Documents/Referencias.pdf";

export default function CountryWindow({position, name, flag, variables}) {
	const {activeCountries, setActiveCountries} = useContext(DataContext);

	// Closes the country window
	const closeWindow = () => {
		let newActiveCountries = activeCountries;
		newActiveCountries = [false, false, false];
		setActiveCountries(newActiveCountries);
	};

	return (
		<div className='country-window'>
			<div className='country-window-header'>
				<p>{position}</p>
				<img src={CloseWindowIcon} alt='Cerrar ventana' onClick={closeWindow}></img>
			</div>
			<div className='country-main-data'>
				<img src={flag} alt={`Bandera de ${name}`}></img>
				<p>{name}</p>
			</div>
			<ComparativeTable countryName={ name } countryVariables={ variables[0] } colombiaVariables={ variables[1] } />
			<a href={References} target={"_blank"} rel={"noreferrer"}>Ver referencias</a>
		</div>
	);
}
